var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"top between bg-slate-700 text-white bg-opacity-50 backdrop-blur-lg z-50"},[_c('menu-app'),_c('router-link',{staticClass:"font-medium tracking-widest uppercase",attrs:{"to":"/"}},[_vm._v("gentleman")]),_c('svg-app',{attrs:{"type":"cart","theme":"w-5"},on:{"action":function($event){return _vm.$router.push('/cart')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }